import DTCPanel from 'src/components/ConnectedVehicle/DTCPanel/DTCPanel';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { ConnectedVehicleActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
    checkedDtc: state.ConnectedVehicle.CheckedDTC,
    importedDtc: state.ConnectedVehicle.ImportedDTC,
    mode: state.Framework.specProfile,
});

const mapDispatchToProps = {
    toggleDtc: ConnectedVehicleActionCreator.ToggleDtc,
};

export default connect(mapStateToProps, mapDispatchToProps)(DTCPanel);